import React from "react";
import { Col, Row, Select, Input, Typography } from "antd";
import DatePicker from "Components/date-picker-localized";
import { FormSection, FormItem } from "Components/form";
import { Controller } from "react-hook-form";
import moment from "moment";

import ParentsList from "Components/form/parent-list/index";

import { DISPLAY_MODE, GENDERS } from "Constants";

export default function TenantTypeForm({
  form,
  childAge,
  setChildAge,
  readOnly = false,
  ...props
}) {
  const { control, errors } = form;

  return (
    <React.Fragment>
      <Row gutter={16}>
        <Col xs={24} lg={6}>
          <FormItem label="Cinsiyet" error={errors.gender} required={true}>
            <Controller
              control={control}
              name="gender"
              readOnly={readOnly}
              as={
                <Select
                  style={{ width: "100%" }}
                  className={readOnly ? "readOnly" : undefined}
                >
                  {Object.keys(GENDERS).map((d) => (
                    <Select.Option key={d} value={d}>
                      {GENDERS[d]}
                    </Select.Option>
                  ))}
                </Select>
              }
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12} lg={9}>
          <FormItem label="Ad" error={errors.name} required={true}>
            <Controller
              control={control}
              name="name"
              as={<Input readOnly={readOnly} placeholder="Ad giriniz" />}
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12} lg={9}>
          <FormItem label="Soyad" error={errors.surname} required={true}>
            <Controller
              control={control}
              name="surname"
              as={<Input readOnly={readOnly} placeholder="Soyad giriniz" />}
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12} lg={12}>
          <FormItem label="Doğum Yeri">
            <Controller
              control={control}
              name="birthPlace"
              as={
                <Input readOnly={readOnly} placeholder="Doğum yeri giriniz" />
              }
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12} lg={12}>
          <FormItem label="Doğum Tarihi">
            <Controller
              control={form.control}
              name={`dateOfBirth`}
              onSelect={(date) => {
                let age = moment(new Date()).diff(date, "months", true);
                setChildAge(Math.floor(age));
              }}
              as={
                <DatePicker
                  readOnly={readOnly}
                  format="DD.MM.YYYY"
                  style={{ width: "100%" }}
                  placeholder="Doğum tarihi giriniz"
                />
              }
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12} lg={12}>
          <FormItem
            label="Kreşe Kabul Tarihi"
            error={errors.dateOfApprovalKinderGarten}
          >
            <Controller
              control={form.control}
              name={`dateOfApprovalKinderGarten`}
              as={
                <DatePicker
                  readOnly={readOnly}
                  format="DD.MM.YYYY"
                  style={{ width: "100%" }}
                  placeholder="Kreşe kabul tarihi giriniz"
                />
              }
            />
          </FormItem>
        </Col>

        <Col xs={24} md={12} lg={12}>
          <FormItem label={childAge ? "Yaşı" : null}>
            <Typography.Text strong>
              {childAge ? childAge + " aylık" : null}
            </Typography.Text>
          </FormItem>
        </Col>
      </Row>
      <FormSection title="Veliler">
        <Row gutter={16}>
          <Col xs={24} md={24} lg={24}>
            <ParentsList
              form={form}
              mode={readOnly ? DISPLAY_MODE.READ_ONLY : DISPLAY_MODE.EDIT}
            />
          </Col>
        </Row>
      </FormSection>
    </React.Fragment>
  );
}
